import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { FuseForgotPassword2Component } from './forgot-password-2.component';

const routes = [
    {
        path     : 'cambiarPass',
        component: FuseForgotPassword2Component
    }
];

@NgModule({
    declarations: [
        FuseForgotPassword2Component
    ],
    imports     : [
        SharedModule,
        RecaptchaModule.forRoot(),
        RecaptchaFormsModule,
        RouterModule.forChild(routes)
    ]
})

export class ForgotPassword2Module
{

}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/forgot-password-2/forgot-password-2.module.ts